import Api2Talk from '../api2talk';

// Item #3 roadmap chatbot JOINT (07/10/2026) — lookup read-only de expedientes do hirer
// pro BusinessHoursInspector. Backend: Mexx.Mexx2Talk.Api/Controllers/WorkHourLookupController.cs
const PATH = '/business-hours';

const getWorkHours = async () => {
  try {
    const response = await Api2Talk.get(`${PATH}/work-hours`);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export { getWorkHours };
